import 'moment/min/locales';
import 'rc-slider/assets/index.css';
import React from 'react';
import { Provider } from 'react-redux';

import './config/i18n';
import './polyfills';

import { LaunchDarklyProvider } from './config/launchDarkly';

import { FeatureFlagsManager } from './config/FeatureFlagsManager';
import { store } from './config/rootStore';
import { LanguagePreferenceListener } from './modules/user/components/LanguagePreferenceListener';
import { Root } from './Root';

import { DSTranslationProvider } from './shared/ds/providers/translationProvider';

/**
 * The loading order ensures conflicts between deprecated styling dependencies are mininized,
 * and that our Vita design system styling is applied on top of those deprecated dependencies.
 * Please do not modify this loading order.
 */
import 'semantic-ui-css/semantic.min.css';
import 'antd/dist/antd.css';
import './shared/styles/scss/style.scss';
import '@modernhealth/vital-components/dist/style.css';

export const App: React.FC = () => (
    <Provider store={store}>
        <LaunchDarklyProvider>
            <LanguagePreferenceListener />
            <DSTranslationProvider>
                <FeatureFlagsManager />
                <Root />
            </DSTranslationProvider>
        </LaunchDarklyProvider>
    </Provider>
);
